// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-bar-area {
  display: flex;
  height: 60px;
  width: 100%;
  margin: auto;
  background-color: #f9e6d3;
}

.left-img,
.right-img {
  z-index: 1;
  height: 100%;
}

.text {
  width: 100%;
  height: 100%;
  z-index: 5;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.action {
  padding: 0px 1px;
  white-space: nowrap;
}

.action-text-en {
  transition: color 320ms cubic-bezier(0.4, 0, 0.6, 1);
  color: #36afad;
}

.action-text-th {
  color: #f3b142;
}

.closebtn {
  position: absolute;
  width: 60px;
  height: 60px;
  z-index: 10;
  right: 0%;
  text-align: center;
  border: none;
  background: none;
  cursor: pointer;
  color: rgb(98, 98, 98);
  font-size: 18px;
  transition: color 320ms cubic-bezier(0.4, 0, 0.6, 1);
}

.closebtn:hover {
  color: black;
}

@media screen and (max-width: 470px) {
  .register-bar-area {
    height: 40px;
  }
  .text {
    font-size: 10px;
  }
  .closebtn {
    width: 40px;
    height: 40px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/register-bar/register-bar.component.scss"],"names":[],"mappings":"AAGA;EACG,aAAA;EACA,YALU;EAMV,WAAA;EACA,YAAA;EACA,yBAAA;AAFH;;AAKA;;EAEG,UAAA;EACA,YAAA;AAFH;;AAKA;EACG,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFH;;AAKA;EACG,gBAAA;EACA,mBAAA;AAFH;;AAIA;EACG,oDAAA;EACA,cAAA;AADH;;AAIA;EACG,cAAA;AADH;;AAIA;EACG,kBAAA;EACA,WA3CU;EA4CV,YA5CU;EA6CV,WAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,oDAAA;AADH;;AAIA;EACG,YAAA;AADH;;AAIA;EACG;IACG,YA7DoB;EA4DxB;EAIC;IACE,eAAA;EAFH;EAKC;IACG,WArEoB;IAsEpB,YAtEoB;IAuEpB,eAAA;EAHJ;AACF","sourcesContent":["$bar-height: 60px;\n$bar-height-small-screen: 40px;\n\n.register-bar-area {\n   display: flex;\n   height: $bar-height;\n   width: 100%;\n   margin: auto;\n   background-color: #f9e6d3;\n}\n\n.left-img,\n.right-img {\n   z-index: 1;\n   height: 100%;\n}\n\n.text {\n   width: 100%;\n   height: 100%;\n   z-index: 5;\n   text-align: center;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   overflow: hidden;\n}\n\n.action {\n   padding: 0px 1px;\n   white-space: nowrap;\n}\n.action-text-en {\n   transition: color 320ms cubic-bezier(0.4, 0, 0.6, 1);\n   color: #36afad;\n}\n\n.action-text-th {\n   color: #f3b142;\n}\n\n.closebtn {\n   position: absolute;\n   width: $bar-height;\n   height: $bar-height;\n   z-index: 10;\n   right: 0%;\n   text-align: center;\n   border: none;\n   background: none;\n   cursor: pointer;\n   color: rgb(98, 98, 98);\n   font-size: 18px;\n   transition: color 320ms cubic-bezier(0.4, 0, 0.6, 1);\n}\n\n.closebtn:hover {\n   color: black;\n}\n\n@media screen and (max-width: 470px) {\n   .register-bar-area {\n      height: $bar-height-small-screen;\n   }\n\n   .text {\n     font-size: 10px;\n   }\n\n   .closebtn {\n      width: $bar-height-small-screen;\n      height: $bar-height-small-screen;\n      font-size: 12px;\n   }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
